<template>
  <div class="home-detail-info-table">
    <div class="home-detail-info-table-description" :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 70%'">
      <div style="">
        <slot name="header"/>
      </div>
      <div style="">
        <slot name="description"/>
        <slot v-if="$vuetify.breakpoint.smAndDown" name="desktop-button"/>
      </div>
    </div>
    <div v-if="!$vuetify.breakpoint.smAndDown" class="home-detail-info-table-button" :style="$vuetify.breakpoint.smAndDown ? 'width: 0%' : 'width: 30%'">
      <slot name="desktop-button"/>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
<style>
.home-detail-info-table {
  display: flex;
  flex-direction: row;
  gap: 5px;
  width: 100%;
}
.home-detail-info-table-description {
  /* width: 70%; */
  display: flex;
  flex-direction: column;
  border-radius: 50px;
  padding: 25px;
  background-color: #121212;
}
.home-detail-info-table-button {
  width: 30%;
  border-radius: 50px;
  background-color: #121212;
}
</style>
